import Card from "./Card";
import DeckSummaryPanel from "./DeckSummaryPanel";
import FilterPanel from "./FilterPanel";
import ManaCurvePanel from "./ManaCurvePanel";
import NavigationPanel from "./NavigationPanel";
import React from "react";
import RelatedContentPanel from "./RelatedContentPanel";
import TypeDistributionPanel from "./TypeDistributionPanel";
import styles from "../styles/Panels.module.scss";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";

const Panels = () => {
  const { dir } = useParams();
  const { data, isLoading } = useSelector((state) => state.pagedata);
  const { search } = useSelector((state) => state.router.location);

  const card = data?.container?.json_dict?.card;
  const cardlists = data?.container?.json_dict?.cardlists;
  const panels = data?.panels;
  const showAdvancedFilters = ["commanders", "decks"].includes(dir);

  if (dir === "combos") {
    const comboHeaderCards = isLoading
      ? [...Array(3)].map(() => ({
          isLoading: true,
        }))
      : cardlists
      ? cardlists[0].cardviews.filter((cardview) => !cardview.dummy)
      : [];
    return (
      <div className={styles.comboHeader}>
        {comboHeaderCards.map((card) => (
          <Card key={card.name} {...card} />
        ))}
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.panels}>
        <div className={styles.panelRow}>
          {(card || isLoading) && (
            <div className={styles.panelColLeft}>
              <div className={styles.panelItem}>
                <div className={styles.panelCard}>
                  <Card {...card} hideName isLoading={isLoading} />
                </div>
              </div>
              <div className={styles.panelItem}>
                <NavigationPanel />
              </div>
            </div>
          )}
          <div className={styles.panelColMid}>
            <div className={styles.panelItem}>
              {!(dir === "decks" && search) && (
                <TypeDistributionPanel {...panels?.piechart} isLoading={isLoading} />
              )}
            </div>
            {dir === "commanders" && (
              <div className={styles.panelItem}>
                <ManaCurvePanel curve={panels?.mana_curve} isLoading={isLoading} />
              </div>
            )}
          </div>
          <div className={styles.panelColRight}>
            <div className={styles.panelItem}>
              <RelatedContentPanel
                articles={panels?.articles}
                isLoading={isLoading}
                relatedVideo={panels?.related_video}
                showAdvancedFilters={showAdvancedFilters}
              />
            </div>
            {showAdvancedFilters && (
              <div className={styles.panelItem}>
                <FilterPanel />
              </div>
            )}
            {dir === "deckpreview" && (
              <div className={styles.panelItem}>
                <DeckSummaryPanel />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Panels;
